import React, { useContext, useState, useEffect } from "react";
import { IconChat, IconEdit, IconStopWatch, IconLocation, IconBarCode, IconPriceTag, IconButtonArrow } from "./Icons";
import PrimaryButton from "./button/PrimaryButton";
import GhostButton from "./button/GhostButton";
import { HeadingVector } from "../home/Icons"; 
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { AppContext } from '../../AppContext';
import axios from '../../backendClient'
 

const OfferDetails = ({ setEditDetails, editDetails, isPathname, offerObject, userNow }) => {

    const location = useLocation();
    const navigate = useNavigate(); 
    const socket = useContext(AppContext); 
    const params = useParams(); 
    const slug = params['*'] ?? location.pathname.split('/').filter(Boolean).pop();
    const eventId = offerObject._id; 
    const [hasAccess, setHasAccess] = useState(false);

    const normalizeBoolean = (value) => {
      return value === true || value === "true" || value === "1" || value === 1 || value === "on";
    };
    
    const isListRoom = normalizeBoolean(offerObject?.isLead);

    const remainingAdmissions = Math.max(
      (offerObject?.maxCapacity || 50) - (offerObject?.ticketsSold || 0),
      0
    );


    /** TO DO WE need to Include Record Count in DB */
    
    const recordsIncluded = offerObject?.recordCount || offerObject?.leadRecordCount || 20;

    const isZeroCost = (rawCost) => {
      // treat null/undefined/empty as free
      if (rawCost === null || rawCost === undefined || rawCost === "") return true;
    
      // handle "0", "0.00", "$0", etc.
      const n = Number(String(rawCost).replace(/[^0-9.-]/g, ""));
      return Number.isFinite(n) && n <= 0;
    };

    const detailsRows = isListRoom
  ? [
      {
        label: "Room Type:",
        value: offerObject?.roomType || offerObject?.tags?.[0] || "Brand Pitch Room",
        img: <IconStopWatch />,
        valueClass: "tag-red"
      },
      {
        label: "Package:",
        value: offerObject?.offerValue ? `$${offerObject.offerValue}` : "Request Access",
        img: <IconPriceTag />,
        valueClass: "tag-blue"
      },
      {
        label: "Records Included:",
        value: offerObject?.recordCount || offerObject?.maxCapacity || 50,
        img: <IconStopWatch />,
        valueClass: "color-black"
      },
      {
        label: "Market:",
        value: offerObject?.location || "United States",
        img: <IconLocation />,
        valueClass: "color-black"
      }
    ]
  : [
      {
        label: "Event Date:",
        value: offerObject?.eventDate
          ? new Date(offerObject.eventDate).toUTCString().split(" 00:00:00")[0]
          : "Date TBD via Chat",
        img: <IconStopWatch />,
        valueClass: "tag-red"
      },
      {
        label: offerObject?.isRetailValue
          ? "Price (Per Person):"
          : offerObject?.isPaymentOffer
            ? "Cash Incentive (Paid by Host to Raffle Winner):"
            : "Learn More",
        value: offerObject?.offerValue ? `$${offerObject.offerValue}` : "Click Below",
        img: <IconPriceTag />,
        valueClass: "tag-blue"
      },
      {
        label: "Start Time:",
        value: offerObject?.eventTime
          ? new Date(
              1970,
              0,
              1,
              offerObject.eventTime.split(":")[0],
              offerObject.eventTime.split(":")[1]
            ).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true
            })
          : "Time TBD via Chat",
        img: <IconStopWatch />,
        valueClass: "color-black"
      },
      {
        label: "Duration (Hours):",
        value: offerObject?.durationHours || "1",
        img: <IconLocation />,
        valueClass: "color-black"
      },
      {
        label: "Location:",
        value: offerObject?.location || "Nationwide",
        img: <IconBarCode />,
        valueClass: "color-black"
      }
    ];

    const proceedToPurchaseTicket = () => {
      const checkCost = offerObject?.offerValue;

      const redirectState = {
        source: 'event',        // use this to distinguish special flow
        slug,
        eventId,
        // 👇 ALWAYS go back to the event page after auth
        returnAfterLogin: `/single/${slug}`,
        returnAfterRegister: `/single/${slug}`,
        cost: offerObject?.offerValue,
        title: offerObject?.eventTitle,
        isLead: offerObject?.isLead
        // You can pass a lightweight event preview for nicer UI later if you want:
        // event: { _id: eventId, slug, name: offerObject?.name, tickets: offerObject?.tickets, currency: offerObject?.currency }
      };

      //navigate('/singlecheckout', { state: redirectState });

      if(isZeroCost(checkCost)){
        navigate('/access-processing', {state: redirectState}); 
        return; //exit out the event otherwise grant below **TO DO call backend function **
      }

      navigate('/singlega', { state: redirectState });
    }


    // ** TO DO ** Must Replace with Handle Join for Event to be able to Joim Chat 
  
    //**NOTE: WE don't have socket on this page technically passed in it would have to be brought in */

    function convertToLocalTime(timeString) {
      return new Date(`1970-01-01T${timeString}Z`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    }

    useEffect(() => {
      let cancel = false;
      (async () => {
        if (!eventId) { return; }
        try {
          const { data } = await axios.post(`/api/events/hasEventAccess`, {eventId: eventId});
          if (!cancel) {
            setHasAccess(!!data?.hasAccess);
            //setLoading(false);
          }
        } catch {
          //if (!cancel) setLoading(false);
        }
      })();
      return () => { cancel = true; };
    }, [eventId]);

  const handleEventChat = async() =>{
    navigate('/chat'); 
  }

  const handleEventChatOld = async() => {
    if(!socket){
       
        if(userNow){
          try{
              const response = await axios.put(`/api/events/changeGuestStatus`,{guestId: userNow._id, eventId: offerObject._id, inviteStatus: "request"}); 
              return navigate('/chat'); 
              
          }
          catch(e){
              alert(e.response.data.message); 
          }
        }
         //use navigate to event listing protected route for sign in 
        navigate('/eventlisting');
    }else{
        //alert('Socket is active!'); //use current user to pass notification for event invite to the host
        // filter out guests who are already "declined, request"
        //** TO DO CREATE SEPARATE PAGE For Single Offer when Logged in with Socket */
        //alert('In Here!'); 
        try{
        // console.log('The data for status:');
        // console.log(userNow._id); 
        // console.log(offerObject._id); 
        // console.log(offerObject.hostUser._id);
        //alert('Requested to Join- check your chats for approval');  
        const response = await axios.put(`/api/events/changeGuestStatus`,{guestId: userNow._id, eventId: offerObject._id, inviteStatus: "request"}); 
        // socket.emit("sendNotification",{
        //     sender: userNow,
        //     receiver: offerObject.hostUser._id, 
        //     type: 4
        // }); 
      }
        catch(e){
          alert(e.response.data.message);
        }
    
        try{
    
            await axios.post('/api/messages/addOfflineNotification',{sender: userNow, offlineUserId: offerObject.hostUser._id,  notificationType: 4, notificationMessage: null });
            navigate('/chat'); 
            
        }catch(e){
            console.log('Failed to set unread notification ', e);
        }
    }
    
};
      
    

    const handleEventForward = (e) => {
     
        e.preventDefault(); // Prevents the default click behavior
        const removeProtocol = (url) => {
          return url.replace(/https?:\/\//g, '');
        };
   
        const url = `https://` + removeProtocol(`${offerObject.forwardUrl}`);
        window.open(url, '_blank', 'noreferrer'); // Opens in a new tab/window securely   
    }

    const DetailsList =  [
        {
          offerEnd: "5/12/24",
          img: <IconStopWatch />,
        },
        {
          price: "145",
          img: <IconPriceTag />,
        },
        {
          time: "3/14/2024 12:00 AM",
          img: <IconStopWatch />,
        },
        {
          location: "Seattle,WA,USA",
          img: <IconLocation />,
        },
      
        {
          onlineCode: "54354311",
          img: <IconBarCode />,
        },
      ];

  return (
    <div
      id="offer-details"
      className="d-flex justify-content-between flex-column h-100"
    >
      <div>
        {" "}
        <h2 className="mb-3 position-relative z-1">
          <span className="position-absolute offer_details_heading_img z-n1">
            <HeadingVector />
          </span>
          {offerObject?.eventTitle}
          <br /> 
          <br /> 
        </h2>
        <div className="detail-parent">
  {detailsRows.map((row, i) => (
    <div key={i} className={`tag ${i > 0 && "mt-1"}`}>
      <div className="d-flex align-items-center">
        <span>{row.img}</span>
        <p className="mb-0 mx-2">{row.label}</p>
        <span className={`${row.valueClass} d-inline-block`}>
          {row.value}
        </span>
      </div>
    </div>
  ))}
</div>
      </div>
      <div className="d-flex flex-column flex-xl-row justify-content-between gap-md-3 gap-2 gap-xl-4 mt-md-4 mt-3">
  <button className="common_btn d-flex align-items-center justify-content-center">
    {isListRoom ? (
      <>
        Records Included: {" "}
        <span className="fw-normal">{recordsIncluded}</span>
      </>
    ) : (
      <>
        Remaining Tickets: {" "}
        <span className="fw-normal">{remainingAdmissions}</span>
      </>
    )}
  </button>
</div>
      {/* <div className="d-flex flex-column flex-xl-row justify-content-between gap-md-3 gap-2 gap-xl-4 mt-md-4 mt-3">  
         <button
          className={`common_btn d-flex align-items-center justify-content-center `}>
                Remaining Tickets : <span className="fw-normal">{(offerObject?.maxCapacity || 50) - (offerObject?.ticketsSold || 0) > 0 ? (offerObject?.maxCapacity || 50) - (offerObject?.ticketsSold || 0): 0}</span>
            </button>
    
      </div> */}
      <div className="d-flex flex-column flex-xl-row justify-content-between gap-md-3 gap-2 gap-xl-4 mt-md-4 mt-3">
        {offerObject.hostUser._id !== userNow?._id && !hasAccess? <button
          className={`common_btn d-flex align-items-center justify-content-center  btnStyle="contact_via_chat"`}
          //onClick={handleEventChat}
          onClick={proceedToPurchaseTicket}
        >
          {isListRoom ? "Get ContactList Access & Join Chat" : (isZeroCost(offerObject?.offerValue)? "Register & Join Free Event" : "Purchase Tickets & Join Chat")}{""}
          <IconChat />
        </button>:  <button
          className={`common_btn d-flex align-items-center justify-content-center  btnStyle="contact_via_chat"`}
          onClick={handleEventChat}
        >
         {isListRoom ? "Open ListRoom & Chat" : "Access My Tickets and Chat"}{""}
          <IconChat />
        </button>}
        {offerObject.hostUser._id !== userNow?._id ? (offerObject.forwardUrl ? <button
          className={`common_btn d-flex align-items-center justify-content-center  btnStyle="contact_via_chat"`}
          onClick={handleEventForward}
        >
          {offerObject.forwardCTA ? `${offerObject.forwardCTA}` : "Continue to Purchase/ Deliverable Link"}{""}
          <IconButtonArrow />
        </button>:''):   <GhostButton
          text="Edit Page"
          btnStyle="edit_page"
          icon={<IconEdit />}
          isModalVisible={() => setEditDetails(!editDetails)}
        />}
      </div>
    </div>
  );
};

export default OfferDetails;
